import React, { Component,useState,useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { makeStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router";
import GlobalApi from "./../../Global";
import SaveIcon from '@material-ui/icons/Save';
import Colors from "./../../Global/colors";
import DarkButton from "./../../Global/DarkButton";
import Button from "@material-ui/core/Button";
import LightButton from "./../../Global/LightButton";
import MiddleHeader from "../middleHeader/middleHeader"
import NoRecords from './../../Global/NoRecords'
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import swal from "@sweetalert/with-react";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { useTranslation } from "react-i18next";

//Images
import help from '../../Assets/help_icon.png';
import helpAr from '../../Assets/help_icon_ar.png';

//Redux
import { useSelector, useDispatch } from "react-redux";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "10px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: `green !important`,
    },
  },

}));


function TemplateResponse() {
  const {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  const [response, setResponse] = useState([""]);
  const [responseDetail, setResponseDetail] = useState([]);
  const [responseDetailIndex, setResponseDetailIndex] = useState(null);
  const [globalresponse, setGlobalresponse] = useState([]);
  const [currentResponseText, setCurrentResponseText] = useState("");
  const [textInput, setTextInput] = useState("");
  const [weight, setWeight] = useState(0);
  const classes = useStyles();


  
  const fetchResponse = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Response/get_all_responses?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log(response.data);
        setGlobalresponse(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(
    () => {
      fetchResponse();
    },
    [company?.id]
  );

  const deleteResponse =(resId) =>{
    console.log("RESID______________________________",resId)
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      response_id: resId.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Response/delete_response?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response________________",response);
        if(response.msg == 'success'){
          swal(t("Success"), t("Response has been Deleted"), "success");
          setCurrentResponseText("")
          setResponseDetail([]);
         setResponseDetailIndex(null);
         fetchResponse()
        }
        else{
          swal(t("Warning"), response.error, "error");
        }
        
      })
      .catch((error) => console.log("error",error));
  }

  const edit_response_detail = (e, i) => {
    if (e.weight == "") e.weight = 0;

    console.log(e, i);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let obj = {
      ...e,
      updated_by: data.user_id,
      response_detail_id: e.id,
      status: "active",
      position: i,
    };

    fetch(GlobalApi + "/ResponseDetail/edit_response_detail", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "Success") {
          fetchResponse();
          swal(t("Success"), t("Response has been updated"), "success");
        }
      })
      .catch((err) => console.log(err));
  };

  const responseClick = (e,data, index) => {
    setCurrentResponseText(data.title)
    console.log("VVVVVVVVVVVVVVVVVVVVVVVV",data,index)
    const ResponseDetailArr = [];
    ResponseDetailArr.push({
      ...data,
    });
    setResponseDetail(ResponseDetailArr);
    setResponseDetailIndex(index);
  };

  const handleCancel = () => {
    setCurrentResponseText("")
    setResponseDetail([]);
    setResponseDetailIndex(null);
  };

  const handleAddResponse = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    fetch(GlobalApi + "/Response/create_response", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        title: "New response added",
        company_id: company.id,
        created_by: data.user_id,
        identifier: "Global",
        status: "active",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.status === "Success") {
          const global = globalresponse.slice(0);
          global.unshift({
            ...data.data,
            ResponseDetails: [],
          });

          console.log("global_______________", global);
          fetchResponse();

          setGlobalresponse(global);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleChange = async (e, parentIndex, childIndex, type) => {
    var arr = [...responseDetail];
    if (type == "title")
      arr[parentIndex].ResponseDetails[childIndex].title = e.target.value;
    if (type == "weight") {
      if (e.target.value >= 0 && e.target.value <= 10)
        arr[parentIndex].ResponseDetails[childIndex].weight = e.target.value;
      else arr[parentIndex].ResponseDetails[childIndex].weight = 0;
    }

    setResponseDetail(arr);
  };

  const handleChangeName = async (e, response) => {
    var arr1 = [...globalresponse];

    arr1[responseDetailIndex].title = e.target.value;
    await setGlobalresponse(arr1);
  };

  const handleResponseEdit = (e, i) => {
    console.log("KJKJKJKJKJKJKJKJKJKJKJKJKJKJK",i)
    let resDetails = [...responseDetail];
    console.log(i, resDetails);
    resDetails[i]["title"] = e.target.value;
    setResponseDetail(resDetails);

    console.log("resDetails", resDetails);
  };

  const handleAddresponseClick = (e, response) => {
    // let newresponse = { title: textInput.current.value };
    // response.ResponseDetails.push(newresponse);
    // // let Response = this.state.ResponseDetail[0];
    // this.setState({ Response: response });
    // textInput.current.value = "";

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    console.log(responseDetail?.ResponseDetails?.length, "LENGTH", response);
    fetch(GlobalApi + "/ResponseDetail/create_response_detail", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        title: textInput,
        weight: weight == "" ? 0 : weight,
        response_id: response.id,
        created_by: data.user_id,
        status: "active",
        position: responseDetail[0]?.ResponseDetails?.length
          ? responseDetail[0]?.ResponseDetails?.length
          : 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "Success") {
          response.ResponseDetails.push(data.data);
          // let Response = this.state.ResponseDetail[0];
          setResponse(response);
          setTextInput("");
          setWeight(0);
          fetchResponse();
        }
      })
      .catch((err) => console.log(err));
  };

  const handleRemove = (e, i) => {
    console.log(e, i);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let obj = {
      status: "frozen",
      updated_by: data.user_id,
      response_detail_id: e.id,
    };

    fetch(GlobalApi + "/ResponseDetail/edit_response_detail", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "Success") {
          console.log("RESPONSE DETAILS>>>>>>>>", responseDetail)
          const filter = responseDetail[0].ResponseDetails.filter(
            (name, j) => j !== i
          );
          responseDetail[0].ResponseDetails = filter;
          setResponseDetail(responseDetail);
          fetchResponse();
        }
      })
      .catch((err) => console.log(err));
  };

  const editResponse = () => {
    // ResponseDetailIndex

    let resDetails = responseDetail;
    let obj = resDetails[0];

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    fetch(GlobalApi + "/Response/edit_response", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        ...obj,
        updated_by: data.user_id,
        response_id: obj.id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "Success") {
          fetchResponse();
          swal(t("Success"), t("Response Saved"), "success");
        }
      })
      .catch((err) => console.log(err));
  };

  return <div className="scrollbarShow2" style={{ backgroundColor: "white", padding: "10px", height: "69vh", overflowY: "auto", overflowX: "hidden" }}>
      <Grid container>
        <Grid item xs={12} md={6} >
          <Grid container direction="row" spacing={1} justify="center" alignItems="center">
            <Grid item xs={8} md={8}>
              <div style={{display:'flex', alignItems:"center"}} >
              <p className="label2" style={{display:'inline',  fontSize: 16, marginTop:0, color: Colors.globalColor8, textTransform: "uppercase" }}>
                {t("Global Response Sets")}
              </p>

              <Tooltip title="Help">

                <a href="https://www.uraudits.com/knowledge-center/custom-global-response-sets/" target="blank" style={{color:Colors.globalColor8}}>
                <img src={language =="ar" ? helpAr : help} height={25} style={{marginLeft:'5px'}}/>
                  </a>
           
              </Tooltip>
              </div>
              <p className="label2" style={{ marginBottom: 5, fontSize: 10, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                {t("Changes will be applied to all templates")}
              </p>
            </Grid>
            <Grid item xs={4} md={4} align="right" justify="center">
              <Button className="ctBtn" style={{ marginRight: "1em", backgroundColor: Colors.globalColor8 }} onClick={(e) => handleAddResponse(e)}>
              {t("Create")}
              </Button>
            </Grid>

            <Grid item xs={12}>
              <div style={{ height: "53vh", display: "flex", width: "100%" }}>
                <div className="scrollbarShow2" style={{ overflowY: "scroll", overflowX: "hidden", width: "100%", padding: window.innerWidth > 700 && "0px 10px 0px 0px" }}>
                  {globalresponse.length == 0 && <NoRecords />}
                  {globalresponse.length > 0 && <List style={{ marginRight: "10px" }}>
                      {globalresponse
                        .slice(0)
                        .reverse()
                        .map((value, index) => {
                          console.log("VALUE*******************************", value);
                          return <ListItem className="col s12  custom-templatediv" style={{ backgroundColor: "white" }}>
                              <div style={{ display: "flex", flexDirtection: "row", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                                <div>
                                  <ListItemText primary={value.title} style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                                </div>
                                <div>
                                  <EditIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} onClick={(e) => responseClick(e, value, index)} />
                                  <DeleteIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} onClick={() => deleteResponse(value)} />
                                </div>
                              </div>
                            </ListItem>;
                        })}
                    </List>}
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}  style={{ paddingLeft: window.innerWidth > 700 && 25, paddingTop: window.innerWidth < 700 && 10, borderLeft: window.innerWidth > 700 && "1px solid #dadada", borderTop: window.innerWidth < 700 && "1px solid #dadada" }}>
          {responseDetail.map((response, index) => {
            console.log(response);
            return <Grid container spacing={2}>
                <Grid item xs={12} style={{ justifyContent: "space-between" }}>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                      <p className="label2" style={{ display: "inline", marginBottom: 5, fontSize: 16, marginTop: 7, color: Colors.globalColor8, textTransform: "uppercase" }}>
                        {t("Edit Response")}
                      </p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={8}>
                  <TextField className="inputTextBox" fullWidth value={response.title} onChange={(e) => handleResponseEdit(e, index)} id="outlined-basic" name="company_name" InputProps={{ classes: { input: classes.resize, root: classes.cssOutlinedInput } }} variant="outlined" autoComplete={"off"} size="medium" />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button className="addBtn" onClick={(e) => editResponse(index)} style={{ backgroundColor: Colors.globalColor8 }}>
                    {t("Save")}
                  </Button>
                  <Button className="cancelBtn shadow" onClick={() => handleCancel()} style={{ display: "inline", marginRight: "1em", backgroundColor: Colors.globalColor9 }}>
                  {t("Cancel")}
                  </Button>
                </Grid>
              </Grid>;
          })}

          <br />
          <div style={{ height: "46vh", display: "flex", width: "100%" }}>
            <div className="scrollbarShow2" style={{ overflowY: "scroll", overflowX: "hidden", width: "100%", padding: window.innerWidth > 700 && "0px 10px 0px 0px" }}>
              {responseDetail.map((response, index) => {
                return <Grid container spacing={1} direction="row" justify="center" alignItems="flex-end">
                    <Grid item xs={3} md={6}>
                      <TextField className="inputTextBox" fullWidth value={textInput} onChange={(e) => setTextInput(e.target.value)} placeholder={t("Title")} id="outlined-basic" name="company_name" InputProps={{ classes: { input: classes.resize, root: classes.cssOutlinedInput } }} variant="outlined" autoComplete={"off"} size="medium" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={3} md={2}>
                      <TextField placeholder="Weight" variant="outlined" type="number" size="small" style={{ width: "100%" }} InputProps={{ inputProps: { min: 0, max: 10 } }} value={weight} onChange={(e) => {
                          e.target.value <= 10 && setWeight(e.target.value);
                        }} />
                    </Grid>
                    <Grid item xs={6} md={4}>
                      <Button className="addBtn" style={{ backgroundColor: Colors.globalColor8, width: "100%" }} onClick={(e) => handleAddresponseClick(e, response, index)}>
                      {t("Add Response")}
                      </Button>
                    </Grid>
                  </Grid>;
              })}
              {responseDetail.map((response, index) => {
                return response.ResponseDetails.map((value, i) => {
                  return <Grid container direction="row" justify="center" alignItems="flex-end" spacing={1}>
                      <Grid item xs={3} md={6}>
                        <TextField className="inputTextBox" fullWidth value={value.title} onChange={(e) => handleChange(e, index, i, "title")} placeholder="Title" id="outlined-basic" name="company_name" InputProps={{ classes: { input: classes.resize, root: classes.cssOutlinedInput } }} variant="outlined" autoComplete={"off"} size="medium" />
                      </Grid>
                      <Grid item xs={3} md={2}>
                        <TextField placeholder="Weight" variant="outlined" type="number" size="small" InputProps={{ inputProps: { min: 0, max: 10 } }} value={value.weight} onChange={(e) => handleChange(e, index, i, "weight")} />
                      </Grid>
                      <Grid item xs={6} md={4} direction="row">
                        <Grid Container direction="row">
                          <Grid item xs={12}>
                            <ButtonGroup variant="contained" color="primary" style={{ width: "100%" }}>
                              <Button style={{ backgroundColor: Colors.globalColor9, width: "50%" }} onClick={(e) => handleRemove(value, i)}>
                                <DeleteIcon style={{ color: Colors.globalColor8 }} />
                              </Button>
                              <Button style={{ backgroundColor: Colors.globalColor8, width: "50%" }} onClick={(e) => edit_response_detail(value, i)}>
                                <SaveIcon style={{ color: Colors.globalColor9 }} />
                              </Button>
                            </ButtonGroup>
                            {/* <ButtonGroup>
                      <LightButton variant="contained" style={{ backgroundColor: Colors.globalColor9 }} onClick={(e) => handleRemove(value, i)}>
                        <DeleteIcon style={{ color: Colors.globalColor8 }} />
                      </LightButton>
                      <DarkButton style={{ backgroundColor: Colors.globalColor8 }} onClick={(e) => edit_response_detail(value, i)}>
                      <SaveIcon style={{ color: Colors.globalColor9 }}/>
                      </DarkButton>
                    </ButtonGroup> */}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>;
                });
              })}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>;
}

export default TemplateResponse


// class templateResponse extends Component {
//   state = {
//     response: [""],
//     ResponseDetail: [],
//     ResponseDetailIndex: null,
//     globalresponse: [],
//     textInput: "",
//     weight:0
//   };

//   fetchResponse = () => {
//     let localstorage = localStorage.getItem("UserData");
//     var data = JSON.parse(localstorage);
//     let token = data.token;
//     let params = {
//       organization_id: data.organization_id,
//     };

//     let query = Object.keys(params)
//       .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
//       .join("&");

//     fetch(GlobalApi + "/Response/get_all_responses?" + query, {
//       method: "GET",
//       headers: {
//         Authorization: "Bearer " + token,
//         "Content-Type": "application/json",
//       },
//     })
//       .then((responseJson) => responseJson.json())
//       .then((response) => {
//         console.log(response.data);
//         this.setState({ globalresponse: response.data });
//       })
//       .catch((error) => console.log(error));
//   };

//   componentDidMount() {
//     this.fetchResponse();
//   }

//   edit_response_detail(e, i) {
//     if(e.weight=='')
//     e.weight=0

//     console.log(e, i);
//     let localstorage = localStorage.getItem("UserData");
//     var data = JSON.parse(localstorage);
//     let token = data.token;
//     let obj = {
//       ...e,
//       updated_by: data.user_id,
//       response_detail_id: e.id,
//       status: "active",
//       position: i,
//     };

//     fetch(GlobalApi + "/ResponseDetail/edit_response_detail", {
//       method: "post",
//       headers: new Headers({
//         Authorization: "Bearer " + token,
//         "Content-Type": "application/json",
//       }),
//       body: JSON.stringify(obj),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "Success") {
//           this.fetchResponse();
//           swal(t("Success"), "Response has been updated", "success");
//         }
//       })
//       .catch((err) => console.log(err));
//   }
//   responseClick(e, data, index) {
//     const ResponseDetail = [];
//     ResponseDetail.push({
//       ...data,
//     });

//     this.setState({
//       ResponseDetail,
//       ResponseDetailIndex: index,
//     });
//   }

//   handleAddResponse() {
//     let localstorage = localStorage.getItem("UserData");
//     var data = JSON.parse(localstorage);
//     let token = data.token;

//     fetch(GlobalApi + "/Response/create_response", {
//       method: "post",
//       headers: new Headers({
//         Authorization: "Bearer " + token,
//         "Content-Type": "application/json",
//       }),
//       body: JSON.stringify({
//         title: "New response added",
//         organization_id: data.organization_id,
//         created_by: data.user_id,
//         identifier: "Global",
//         status: "active",
//       }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log(data);
//         if (data.status === "Success") {
//           const global = this.state.globalresponse.slice(0);
//           global.push({
//             ...data.data,
//             ResponseDetails: [],
//           });
//           this.fetchResponse();

//           this.setState({ globalresponse: global });
//         }
//       })
//       .catch((err) => console.log(err));
//   }
//   async handleChange(e, parentIndex, childIndex,type) {
//     var arr = [...this.state.ResponseDetail];
//     if(type=="title")
//     arr[parentIndex].ResponseDetails[childIndex].title = e.target.value;
//     if(type=="weight"){
    
//     if( e.target.value >=0 && e.target.value <=10)
//     arr[parentIndex].ResponseDetails[childIndex].weight = e.target.value;
//     else
//     arr[parentIndex].ResponseDetails[childIndex].weight = 0
//     }

//     this.setState({ ResponseDetail: arr });
//   }

//   async handleChangeName(e, response) {
//     var arr1 = [...this.state.globalresponse];

//     arr1[this.state.ResponseDetailIndex].title = e.target.value;
//     await this.setState({ globalresponse: arr1 });
//   }

//   handleResponseEdit = (e, i) => {
//     let { name, value } = e.target;
//     let resDetails = this.state.ResponseDetail;
//     console.log(i, resDetails);
//     resDetails[i]["title"] = value;

//     this.setState({
//       ResponseDetail: resDetails,
//     });
//   };

//   handleAddresponseClick(e, response) {
//     // let newresponse = { title: textInput.current.value };
//     // response.ResponseDetails.push(newresponse);
//     // // let Response = this.state.ResponseDetail[0];
//     // this.setState({ Response: response });
//     // textInput.current.value = "";

//     let localstorage = localStorage.getItem("UserData");
//     var data = JSON.parse(localstorage);
//     let token = data.token;
//     console.log(
//       this.state.ResponseDetail?.ResponseDetails?.length,
//       "LENGTH",
//       response
//     );
//     fetch(GlobalApi + "/ResponseDetail/create_response_detail", {
//       method: "post",
//       headers: new Headers({
//         Authorization: "Bearer " + token,
//         "Content-Type": "application/json",
//       }),
//       body: JSON.stringify({
//         title: this.state.textInput,
//         weight:this.state.weight == '' ? 0 : this.state.weight,
//         response_id: response.id,
//         created_by: data.user_id,
//         status: "active",
//         position: this.state.ResponseDetail[0]?.ResponseDetails?.length
//           ? this.state.ResponseDetail[0]?.ResponseDetails?.length
//           : 0,
//       }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "Success") {
//           response.ResponseDetails.push(data.data);
//           // let Response = this.state.ResponseDetail[0];
//           this.setState({ Response: response });
//           this.setState({ textInput: "",weight:0 });
//           this.fetchResponse();
//           // textInput.current.value = "";
//         }
//       })
//       .catch((err) => console.log(err));
//   }
//   handleRemove(e, i) {
//     console.log(e, i);
//     let localstorage = localStorage.getItem("UserData");
//     var data = JSON.parse(localstorage);
//     let token = data.token;
//     let obj = {
//       status: "frozen",
//       updated_by: data.user_id,
//       response_detail_id: e.id,
//     };

//     fetch(GlobalApi + "/ResponseDetail/edit_response_detail", {
//       method: "post",
//       headers: new Headers({
//         Authorization: "Bearer " + token,
//         "Content-Type": "application/json",
//       }),
//       body: JSON.stringify(obj),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "Success") {
//           const filter = this.state.ResponseDetail[0].ResponseDetails.filter(
//             (name, j) => j !== i
//           );
//           this.state.ResponseDetail[0].ResponseDetails = filter;
//           this.setState({ ResponseDetail: this.state.ResponseDetail });
//         }
//       })
//       .catch((err) => console.log(err));
//   }

//   editResponse() {
//     // ResponseDetailIndex

//     let resDetails = this.state.ResponseDetail;
//     let obj = resDetails[0];

//     let localstorage = localStorage.getItem("UserData");
//     var data = JSON.parse(localstorage);
//     let token = data.token;

//     fetch(GlobalApi + "/Response/edit_response", {
//       method: "post",
//       headers: new Headers({
//         Authorization: "Bearer " + token,
//         "Content-Type": "application/json",
//       }),
//       body: JSON.stringify({
//         ...obj,
//         updated_by: data.user_id,
//         response_id: obj.id,
//       }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "Success") {
//           this.fetchResponse();
//           swal(t("Success"), "Response Saved", "success");
//         }
//       })
//       .catch((err) => console.log(err));
//   }

//   render() {
//     if (localStorage.getItem("UserData") === null) {
//       return <Redirect to={"/signin"} />;
//     }
//     var retrievedData = localStorage.getItem("UserData");
//     var data = JSON.parse(retrievedData);
//     if (data.token == null) {
//       return <Redirect to={"/signin"} />;
//     }

//     return (
//       <Container>
//         <br/>
//         <Grid container>
//           <Grid item xs={12} md={6}>
//             <Grid
//               container
//               direction="row"
//               justify="center"
//               alignItems="center"
//             >
//               <Grid item xs={12} md={6}>
//                 <Typography variant="h5" style={{color:Colors.buttonTextColor}}>{t("Global Response Sets")}</Typography>
//                 <Typography variant="p">
//                   Changes will be applied to all templates
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} md={6} align="right" justify="center">
//                 <DarkButton
//                   onClick={(e) => this.handleAddResponse(e)}
//                   style={{ marginTop: "10px", marginRight: "1em" }}
//                   size="large"
//                 >
//                   Create
//                 </DarkButton>
//               </Grid>

//               <Grid item xs={12}>
//                 <List>
//                   {this.state.globalresponse.map((value, index) => {
//                     return (
//                       <ListItem
//                         className="col s12 left-align custom-templatediv"
//                         onClick={(e) => this.responseClick(e, value, index)}
//                       >
//                         <ListItemText primary={value.title} />
//                       </ListItem>
//                     );
//                   })}
//                 </List>
//               </Grid>
//             </Grid>
//           </Grid>
//           <Grid item xs={12} md={6} style={{ paddingLeft: 25 }}>
//             {this.state.ResponseDetail.map((response, index) => {
//               // console.log(response)
//               return (
//                 <Grid container spacing={2}>
//                   <Grid item xs={6}>
//                     <TextField
//                       id="standard-basic"
//                       value={response.title}
//                       onChange={(e) => this.handleResponseEdit(e, index)}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <DarkButton onClick={(e) => this.editResponse(index)}>
//                       {t("Save")}
//                     </DarkButton>
//                   </Grid>
//                 </Grid>
//               );
//             })}

//             {this.state.ResponseDetail.map((response, index) => {
//               return (
//                 <Grid
//                   container
//                   spacing={2}
//                   direction="row"
//                   justify="center"
//                   alignItems="flex-end"
//                 >
//                   <Grid item xs={3} md={3}>
//                     <TextField
//                       id="standard-basic"
//                       value={this.state.textInput}
//                       onChange={(e) =>
//                         this.setState({ textInput: e.target.value })
//                       }
//                       fullWidth
//                     />
//                   </Grid>
//                   <Grid item xs={3} md={3}>
//                       <TextField
//                         placeholder="Weight"
//                         variant="outlined"
//                         type="number"
//                         size="small"
//                         InputProps={{ inputProps: { min: 0, max: 10 } }}
//                         value={this.state.weight}
//                         onChange={(e) => this.setState({ weight: e.target.value })}
//                       />
//                     </Grid>
//                   <Grid item xs={6}>
//                     <DarkButton
//                       onClick={(e) =>
//                         this.handleAddresponseClick(e, response, index)
//                       }
//                     >
//                       Add Response{" "}
//                     </DarkButton>
//                   </Grid>
//                 </Grid>
//               );
//             })}
//             {this.state.ResponseDetail.map((response, index) => {
//               return response.ResponseDetails.map((value, i) => {
//                 return (
//                   <Grid
//                     container
//                     direction="row"
//                     justify="center"
//                     alignItems="flex-end"
//                     spacing={2}
//                   >
//                     <Grid item xs={3} md={3}>
//                       <TextField
//                         value={value.title}
//                         id="standard-basic"
//                         onChange={(e) => this.handleChange(e, index, i,"title")}
//                       />
//                     </Grid>
//                     <Grid item xs={3} md={3}>
//                       <TextField
//                         placeholder="Weight"
//                         variant="outlined"
//                         type="number"
//                         size="small"
//                         InputProps={{ inputProps: { min: 0, max: 10 } }}
//                         value={value.weight}
//                         onChange={(e) => this.handleChange(e, index, i,"weight")}
//                       />
//                     </Grid>
//                     <Grid item xs={6} direction="row">
//                       <Grid Container direction="row">
//                         <Grid item xs={12}>
//                           <ButtonGroup>
//                             <LightButton
//                               variant="contained"
//                               size="large"
//                               onClick={(e) => this.handleRemove(value, i)}
//                             >
//                               <DeleteIcon />
//                             </LightButton>
//                             <DarkButton
//                               onClick={(e) =>
//                                 this.edit_response_detail(value, i)
//                               }
//                             >
//                               {t("Save")}
//                             </DarkButton>
//                           </ButtonGroup>
//                         </Grid>
//                       </Grid>
//                     </Grid>
//                   </Grid>
//                 );
//               });
//             })}
//           </Grid>
//         </Grid>
//         <br />
//         <br />
//         <br />
//         <br />
//         <br />
//       </Container>
//     );
//   }
// }

// export default templateResponse;
